var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMdiMagnify(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6875 3.375C12.6269 3.375 14.4869 4.14542 15.8582 5.51678C17.2296 6.88814 18 8.7481 18 10.6875C18 12.4987 17.3362 14.1637 16.245 15.4462L16.5487 15.75H17.4375L23.0625 21.375L21.375 23.0625L15.75 17.4375V16.5487L15.4462 16.245C14.1194 17.3776 12.432 17.9999 10.6875 18C8.7481 18 6.88814 17.2296 5.51678 15.8582C4.14542 14.4869 3.375 12.6269 3.375 10.6875C3.375 8.7481 4.14542 6.88814 5.51678 5.51678C6.88814 4.14542 8.7481 3.375 10.6875 3.375ZM10.6875 5.625C7.875 5.625 5.625 7.875 5.625 10.6875C5.625 13.5 7.875 15.75 10.6875 15.75C13.5 15.75 15.75 13.5 15.75 10.6875C15.75 7.875 13.5 5.625 10.6875 5.625Z",
    fill: "#B5B5B5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiMagnify);
export default __webpack_public_path__ + "static/media/mdi_magnify.5bff46d0397a57ee12f9e450052515f2.svg";
export { ForwardRef as ReactComponent };